/**
 * v120 — Impersonation banner. Renders a fixed red stripe at the very top
 * of the app when a Super-Admin is signed in as another user via
 * `POST /api/admin/impersonate`. Provides a one-click "Exit" that restores
 * the admin's original session.
 */
import { AlertTriangle, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function ImpersonationBanner() {
  const { impersonation, exitImpersonation } = useAuth();
  if (!impersonation) return null;
  return (
    <div
      className="sticky top-0 z-[100] bg-coral text-white border-b-4 border-ink shadow-brutalSm"
      data-testid="impersonation-banner"
    >
      <div className="max-w-7xl mx-auto flex flex-wrap items-center gap-2 sm:gap-4 px-3 py-2">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <AlertTriangle className="w-4 h-4 flex-shrink-0" strokeWidth={3} />
          <p className="text-xs sm:text-sm font-bold truncate">
            You are impersonating{" "}
            <span className="underline decoration-2">
              {impersonation.target_name || impersonation.target_email || impersonation.target_user_id}
            </span>
            {impersonation.target_email && impersonation.target_name ? (
              <span className="opacity-80"> ({impersonation.target_email})</span>
            ) : null}
          </p>
        </div>
        <button
          type="button"
          onClick={exitImpersonation}
          className="border-2 border-ink bg-white text-ink px-3 py-1 text-xs font-bold shadow-brutalSm inline-flex items-center gap-1 hover:translate-x-0.5 hover:translate-y-0.5 flex-shrink-0"
          data-testid="impersonation-exit-btn"
        >
          <LogOut className="w-3 h-3" /> Exit to admin
        </button>
      </div>
    </div>
  );
}
